import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
import { LessonPlan } from '../types'

export interface LessonPlansReducer {
  lessonPlans: Record<number, LessonPlan[]>
}

const initialState: LessonPlansReducer = {
  lessonPlans: {}
}

interface FetchLessonPlanPayload {
  unitId: number
}
export type FetchLessonPlansAction = PayloadAction<FetchLessonPlanPayload>
export const FETCH_LESSON_PLANS = createAction<FetchLessonPlanPayload>('lesson_plans_reducer/fetch_lesson_plans')
interface FetchLessonPlanSuccessPayload {
  unitId: number
  lessonPlans: LessonPlan[]
}
export type FetchLessonPlanSuccessAction = PayloadAction<FetchLessonPlanSuccessPayload>
export const FETCH_LESSON_PLANS_SUCCESS = createAction<FetchLessonPlanSuccessPayload>(
  'lesson_plans_reducer/fetch_lesson_plans_success'
)
export const FETCH_LESSON_PLANS_FAIL = createAction('lesson_plans_reducer/fetch_lesson_plans_fail')

interface ChangeLessonPlanPayload {
  lessonId: string
  lessonPlanId: string
}
export type ChangeLessonPlanActionType = PayloadAction<ChangeLessonPlanPayload>
export const CHANGE_LESSON_PLAN = createAction<ChangeLessonPlanPayload>('lesson_plan_reducer/change_lesson_plan')
export const CHANGE_LESSON_PLAN_SUCCESS = createAction('lesson_plan_reducer/change_lesson_plan_success')
export const CHANGE_LESSON_PLAN_FAIL = createAction('lesson_plan_reducer/change_lesson_plan_fail')

interface CreateLessonPlanPayload {
  unitId: number
  name: string
}
export type CreateLessonPlanActionType = PayloadAction<CreateLessonPlanPayload>
export const CREATE_LESSON_PLAN = createAction<CreateLessonPlanPayload>('lesson_plans_reducer/create_lesson_plan')
interface CreateLessonPlanSuccessPayload {
  unitId: number
  lessonPlan: LessonPlan
}
export type CreateLessonPlanSuccessAction = PayloadAction<CreateLessonPlanSuccessPayload>
export const CREATE_LESSON_PLAN_SUCCESS = createAction<CreateLessonPlanSuccessPayload>(
  'lesson_plans_reducer/create_lesson_plan_success'
)
export const CREATE_LESSON_PLAN_FAIL = createAction('lesson_plans_reducer/create_lesson_plan_fail')

interface ReorderLessonPlansPayload {
  unitId: number
  ids: number[]
}
export type ReorderLessonPlansAction = PayloadAction<ReorderLessonPlansPayload>
export const REORDER_LESSON_PLANS = createAction<ReorderLessonPlansPayload>('lesson_plans_reducer/reorder_lesson_plans')
interface ReorderLessonPlansSuccessPayload {
  unitId: number
  lessonPlans: LessonPlan[]
}
export const REORDER_LESSON_PLANS_SUCCESS = createAction<ReorderLessonPlansSuccessPayload>(
  'lesson_plans_reducer/reorder_lesson_plans_success'
)
export const REORDER_LESSON_PLANS_FAIL = createAction('lesson_plans_reducer/reorder_lesson_plans_fail')

interface DeleteLessonPlanPayload {
  lessonPlanId: number
  unitId: number
}
export type DeleteLessonPlanAction = PayloadAction<DeleteLessonPlanPayload>
export const DELETE_LESSON_PLAN = createAction<DeleteLessonPlanPayload>('lesson_plans/delete_lesson_plan')
export const DELETE_LESSON_PLAN_SUCCESS = createAction('lesson_plans/delete_lesson_plan_success')
export const DELETE_LESSON_PLAN_FAIL = createAction('lesson_plans/delete_lesson_plan_fail')

export const lessonPlansReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_LESSON_PLANS_SUCCESS, (state, action) => {
      return { ...state, lessonPlans: { ...state.lessonPlans, [action.payload.unitId]: action.payload.lessonPlans } }
    })
    .addCase(CREATE_LESSON_PLAN_SUCCESS, (state, action) => {
      return {
        ...state,
        lessonPlans: {
          ...state.lessonPlans,
          [action.payload.unitId]: [...state.lessonPlans[action.payload.unitId], action.payload.lessonPlan]
        }
      }
    })
    .addCase(REORDER_LESSON_PLANS_SUCCESS, (state, action) => {
      return {
        ...state,
        lessonPlans: {
          ...state.lessonPlans,
          [action.payload.unitId]: action.payload.lessonPlans
        }
      }
    })
})
